<template>
  <ul>
    <li v-for="concept in concepts" :key="concept.id">
      <span @click.stop="$emit('select-concept-uri', concept.uri)">{{
        conceptLabel(concept)
      }}</span>
    </li>
  </ul>
</template>

<script>
  import { CONCEPTS_ARE_LN } from '@/store/constants';

  export default {
    name: 'ConceptList',
    props: {
      concepts: {
        type: Array,
      },
    },
    emits: ['select-concept-uri'],
    methods: {
      // TODO: Refactor with ConceptDetail
      conceptLabel(concept) {
        const label = concept.label || '<Unknown>';
        if (CONCEPTS_ARE_LN) {
          return `${label} (${concept.data?.code})`;
        }
        return label;
      },
    },
  };
</script>

<!-- TODO: Refactor with Text Structure Widget -->
<style scoped lang="scss">
  span {
    user-select: none;
    cursor: pointer;

    &:hover {
      color: #4d4ddd;
    }
  }
</style>
